// use same pattern as every other duck
// eslint-disable-next-line import/prefer-default-export
export const SET_ATTRIBUTE = 'SET_ATTRIBUTE';
